module.exports = __webpack_public_path__ + "assets/img/500.051e23e0.png";